import moment from 'moment';

export const getToken = () => {
  return localStorage.getItem('token') || null;
};

export const getAmsToken = () => {
  return localStorage.getItem('amsToken') || null;
};

export const dataUser = () => {
  return localStorage.getItem('headData') || null;
};

export const spocLocationDetails = () => {
  return localStorage.getItem('spocLocationDetails') || null;
};
export const spocLocationDetailsZoho = () => {
  return localStorage.getItem('spocLocationDetailsZoho') || null;
};

export const allLocationWithShortName = () => {
  return localStorage.getItem('allLocationWithShortName') || null;
}

export const dataLocation = () => {
  const locData = localStorage.getItem('locationData');

  // return "[24,30,15,35,12,11,16,29,3,6,38,2,13,37,1,32,20]"

  return locData && Array.isArray(JSON.parse(locData)) ? locData : '[]';
};

export function removeDuplicateObjectFromArray(array, key) {
  var check = new Set();
  return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
}

export const arrayOfObjectIntersection = (array1, array2, key) => {
  var kiran = [];
  for (let i = 0; i < array1.length; i++) {
    for (let j = 0; j < array2.length; j++) {
      if (array1[i][key] === array2[j][key]) {
        kiran.push(array2[j]);
      }
    }
  }
  return kiran;
};

export const onTogle = (context, name, newValue, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        value: newValue,
      }),
    },
    callback && callback,
  );
};
export const onChange = (context, name, newValue, callback) => {
  context.setState(
    { [name]: { ...context.state[name], value: newValue } },
    callback && callback,
  );
};
export const onArrayChange = (context, name, value, callback) => {
  const updatedValue = context.state[name].value.concat(value);
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        value: updatedValue,
      }),
    },
    callback && callback,
  );
};
export const setOptions = (context, name, value, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        options: value,
      }),
    },
    callback && callback,
  );
};
export const clearOptions = (context, name, value, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        options: [],
      }),
    },
    callback && callback,
  );
};
export const setError = (context, name, error, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), { error }),
    },
    callback && callback,
  );
};
export const setRequired = (context, name, newIsRequired, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        isRequired: newIsRequired,
      }),
    },
    callback && callback,
  );
};
export const setShow = (context, name, newShow, callback) => {
  context.setState(
    {
      [name]: Object.assign(Object.assign({}, context.state[name]), {
        show: newShow,
      }),
    },
    callback && callback,
  );
};
export const validateForm = context => {
  const st = JSON.parse(JSON.stringify(context.state));
  let status = true;
  for (let key in st) {
    if (st.hasOwnProperty(key) && st[key]) {
      const name = st[key].name;
      const isRequired = st[key].isRequired;
      const value = st[key].value != null ? st[key].value : '';
      if (isRequired && value.length === 0) {
        status = false;
        setError(context, name, 'This field is required');
      } else if (isRequired && value.length > 0) {
        setError(context, name, '');
      }
    }
  }
  return status;
};
export const toLowercaseAndRemoveSpecialChar = name => {
  const formattedName = name.toLowerCase().replace(/ /g, '-');
  return formattedName;
};
export const toUperCaseFirstChr = value => {
  if (value.length > 0) return value.toUpperCase().substr(0, 2);
  return '';
};
export const removeSpaceAndAddHyphen = param => {
  const formattedName = param.toLowerCase().replace(/ /g, '-');
  return formattedName;
};
export const replaceForwardSlashWithComma = param => {
  const formattedName = param.toLowerCase().replace(/\//g, ',');
  return formattedName;
};
export const removeHyphenAndAddSpace = param => {
  const formattedName = param.toLowerCase().replace(/-/g, ' ');
  return formattedName;
};
export const removeCommas = param => {
  const formattedName = param.toLowerCase().replace(/,/g, '');
  return formattedName;
};
export const toTitleCase = str => {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export const isEmpty = input => {
  const dataType = typeof input;
  if (input === null || input === undefined) {
    return true;
  } else if (dataType === 'string') {
    const parsedValue = input.replace(/ /g, '').replace(/(?:\r\n|\r|\n)/g, '');
    if (parsedValue.length === 0) {
      return true;
    }
  } else if (dataType === 'object') {
    return Object.keys(input).length === 0;
  }
  return false;
};
export const replaceLineBreakWithBR = input => {
  return input.replace(/(?:\r\n|\r|\n)/g, '<br/>');
};

export const titleCase = str => {
  const splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
};

export const getRelativeTime = date => {
  const d = new Date(date * 1000);
  return moment(d).fromNow();
};
export const isValid24HourTime = timeStr =>
  timeStr.search(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/) != -1;
export const isValidDateFormat = dateString =>
  dateString.search(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/) !=
  -1;
export const isValidDate = dateString => {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateString.match(regEx)) return false; // Invalid format
  var d = new Date(dateString);
  var dNum = d.getTime();
  if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0, 10) === dateString;
};
export const clearUnwanted = model => {
  for (var key in Object.assign({}, model)) {
    if (model[key] == null) delete model[key];
  }
  return model;
};
export function isEquivalent(a, b, skip) {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length != bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    if (propName == skip) continue;
    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  // If we made it this far, objects
  // are considered equivalent
  return true;
}
export const textTransform = str => {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export const appendFile = modle => {
  const formData = new FormData();
  if (modle.constructor === Array) {
    modle.forEach((m, i) => {
      // let key: string = k, value: any = v
      // for (const [k, v] of Object.entries(m)) {
      // key = (!!value) && (value.constructor === Array) ? `${key}[]` : key
      // value = (!!value) && (value.constructor === Array) ? value.map((v: any) => JSON.stringify(v)) : value
      formData.append(`tada[${i}]`, JSON.stringify(m));
      formData.append(`file[${i}]`, m.img);
      // }
    });
    return formData;
  } else {
    for (const [k, v] of Object.entries(modle)) {
      let key = k,
        value = v;
      key = !!value && value.constructor === Array ? `${key}[]` : key;
      value =
        !!value && value.constructor === Array
          ? value.map(v => JSON.stringify(v))
          : value;
      formData.append(key, value);
    }
    return formData;
  }
};

export const Model = (obj, newObj = {}) => {
  const newObject = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] != undefined && obj[key].constructor === Object)
        newObject[key] = obj[key].value;
      else newObject[key] = obj[key];
    }
  }
  return { ...newObject, ...newObj };
};

export const restrictEqualSign = (e, i) => {
  const re = /[=]+/g;
  if (re.test(e.key)) {
    e.preventDefault();
  }
};

export const User = () => {
  const token = dataUser();
  try {
    if (token) {
      // const base64Url = token.split('.')[1];
      return JSON.parse(token);
    }
    return undefined;
  } catch (error) {
    return false;
  }
};
export const logoutHandler = () => {
  localStorage.removeItem('token');

  localStorage.removeItem('amsToken');

  localStorage.removeItem('headData');
  localStorage.removeItem('locationData');

  localStorage.removeItem('setCloudKitchModal');

  window.location.href = '/';
};
